import { useEffect } from 'react';
import { useGetTerminalsWithOngoingPayments } from '@ordr-as/payment-service-types/epos';
import { useTerminalStore } from '../context/TerminalStore';

export function useTerminalPolling(terminalIds: string[], locationId: number) {
  const reconcile = useTerminalStore((s) => s.actions.reconcileFromPolling);

  const { data } = useGetTerminalsWithOngoingPayments(
    locationId,
    { ids: terminalIds },
    {
      query: {
        // Increase this once we've built confidence in the SSE solution
        refetchInterval: 15_000,
        enabled: terminalIds.length > 0,
      },
    }
  );

  useEffect(() => {
    if (data) {
      reconcile(data);
    }
  }, [data, reconcile]);
}
